<div class="modal {{modal_class}}" id="{{id}}" tabindex="0" role="dialog"
     data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog {{dialog_class}}">
    <div class="modal-content {{content_class}} {{#if full_width}}fullWidth{{/if}}">
      <div class="modal-header {{header_class}}">
        <button type="button" class="close" {{#unless prevent_close_feedback}}data-close="true"{{/unless}} data-dismiss="modal" {{#unless sr_close_caption}}aria-label="{{t 'closeModal'}}"{{/unless}}>
          {{>icon uuid=cid prefix="fal" name="fa-times" size="fa-lg"}}
          <span class="screen-reader-content">{{#if sr_close_caption}}{{t sr_close_caption}}{{else}}{{t close_caption}}{{/if}}</span>
        </button>
        <{{heading_level}} class="modal-title {{title_class}}" id="{{id}}_label">{{t header}}</{{heading_level}}>
      </div>
      <div class="modal-body {{body_class}}" tabindex="0">
        {{#if description}}<p>{{t description}}</p>{{/if}}
        {{#if blocks}}
          <div data-region="{{cid}}-modal-blocks"></div>
        {{/if}}
      </div>
      {{#unless no_footer}}
        <div class="modal-footer {{footer_class}}">
          <button type="button" class="modal-footer-close {{#if button_class}}{{button_class}}{{else}}btn btn-default{{/if}}" data-dismiss="modal" {{#unless prevent_close_feedback}}data-close="true"{{/unless}}>
            {{#if sr_close_caption}}
              <span aria-hidden="true">{{t close_caption}}</span>
              <span class="screen-reader-content">{{t sr_close_caption}}</span>
            {{else}}
              {{t close_caption}}
            {{/if}}
          </button>
          {{f 'editblock' '' cid forge_path 'modal'}}
        </div>
      {{/unless}}
    </div>
  </div>
</div>
